import { eTransactionType } from '../eTransactionType';
import { eEndorsements } from '../../../../ui-toolkit/enums/eEndorsements';

export interface ILoanCalcEndorsementConfigResponse {
  transactionTypes: eTransactionType[];
  endorsementType: eEndorsements;
  minimum: number;
  percentOfLoan: number;
}

export interface ILoanCalcEndorsementConfigData {
  transactionTypes: eTransactionType[];
  endorsementType: eEndorsements;
  minimum: number;
  percentOfLoan: number;
}

export const convertILoanCalcEndorsementConfigResponseToILoanCalcEndorsementConfigData = (
  response: ILoanCalcEndorsementConfigResponse
): ILoanCalcEndorsementConfigData => ({ ...response });
